<template>
  <div align="center" class="w-100 mb-4" style="position: relative; z-index: 100">
    <div class="app-board border pt-3 pb-3" style="width: 800px;">
      <h1 class="text-primary mb-4">MRT LOG</h1>
      <el-row :key="key" class="mb-3" v-for="(prop, key) in log">
        <span v-if="isAllowedKey(key)">
            <span v-if="keysToOpen(key)">
              <el-col :span="8" class="text-left pl-3 text-capitalize font-weight-bold">{{
                  key.replaceAll('_', ' ')
                }}:</el-col>
              <el-col :span="16" class="text-left pr-3">
                <el-collapse accordion>
                  <el-collapse-item name="1">
                    <template slot="title">
                      <b>Open</b>
                    </template>
                    {{ decodeURIComponent(prop) }}
                  </el-collapse-item>
                </el-collapse>
              </el-col>
          </span>
          <span v-else>
            <el-col :span="8" class="text-left pl-3 text-capitalize  font-weight-bold">{{
                key.replaceAll('_', ' ')
              }}:</el-col>
            <el-col :span="16" class="text-left pr-3">{{ decodeURIComponent(prop) }}</el-col>
          </span>
        </span>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    log: {
      required: true
    }
  },
  methods: {
    isAllowedKey(key) {
      let keys = ['rtp_use_codec_string']
      return keys.indexOf(key) == -1
    },
    keysToOpen(key) {
      let keys = ['rtp_local_sdp_str', 'switch_r_sdp']
      return keys.indexOf(key) !== -1
    }
  }
}
</script>
